"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CalloutAlert = function CalloutAlert(_ref) {
  var error = _ref.error;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "callout alert"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Oops!"), /*#__PURE__*/_react["default"].createElement("p", null, error.description), /*#__PURE__*/_react["default"].createElement("p", null, "You may also try ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://topwallpaperpc.com/how-to-force-refresh-browser-cache-to-load-newer-webpages/"
  }, "to reload bypassing your browser cache"), " to avoid seeing stale data or errors."), /*#__PURE__*/_react["default"].createElement("p", null, "If the error persists, in order to help us debug the issue, please copy the URL from your browser and the error message below and send it to us via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.ebi.ac.uk/support/gxa"
  }, "the EBI Support & Feedback system"), ":"), /*#__PURE__*/_react["default"].createElement("code", {
    className: "small"
  }, "".concat(error.name, ": ").concat(error.message))));
};

CalloutAlert.propTypes = {
  error: _propTypes["default"].shape({
    description: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired,
    message: _propTypes["default"].string.isRequired
  })
};
var _default = CalloutAlert;
exports["default"] = _default;